import { twMerge } from '@/lib/classname/twMerge'
import { DOT_SEPARATOR } from '@/lib/utils/text-utils'
import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'
import React, { Fragment } from 'react'
import { InlineListItem } from './_components/InlineListItem'

export const alignementVariants = {
  spaced: 'w-full justify-between',
  'spaced-desktop': 'w-full desktop:justify-between',
  centered: 'gap-x-1 justify-center',
  left: 'gap-x-1 justify-left',
}

const inlineListCva = cva('flex flex-wrap items-center gap-x-0.5', {
  variants: {
    alignement: alignementVariants,
  },
})

type inlineListVariantProps = VariantProps<typeof inlineListCva>

export type InlineListProps = React.PropsWithChildren<inlineListVariantProps> & {
  className?: string
}

export function InlineList({
  alignement = 'spaced',
  children,
  className,
}: InlineListProps): React.ReactElement | null {
  const items = React.Children.toArray(children)

  if (items.length === 0) {
    return null
  }

  return (
    <div className={twMerge(className, inlineListCva({ alignement }))} data-testid="inline-list">
      {items.map((item, index) => {
        return (
          // Item can be of any type; it's not possible to know its props.
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={index}>
            {index > 0 && DOT_SEPARATOR}
            {item}
          </Fragment>
        )
      })}
    </div>
  )
}

InlineList.Item = InlineListItem
